/* OcuLabs homepage v3 header menus (28 Oct 2026), rebuilt from thepetlabco.com's navigation.
   Desktop: menus open on hover into one shared panel; moving between menus animates the panel height, the content
   swaps instantly, and the panel closes 150ms after the pointer leaves (the source uses Radix NavigationMenu).
   Category rows switch the right-hand content on hover. Click and keyboard work too.
   Search: the pill slides in over the right-hand links and shows live product results.
   Phone and small tablet (under 1024px): the menu slides in from the left; categories are accordions. */
(function () {
  'use strict';
  var head = document.querySelector('[data-oc3-head]');
  if (!head) return;
  var mmv = head.querySelector('[data-oc3-mmv]');
  var overlay = document.querySelector('[data-oc3-overlay]');
  var mob = document.querySelector('[data-oc3-mob]');
  var desktop = window.matchMedia('(min-width: 1024px)');
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var current = null;
  var openedBy = null;
  var openedAt = 0;
  var closeTimer = null;

  // Menu images load before the first open, so tiles are never empty (hidden lazy images wait otherwise).
  var warmed = false;
  function warm() {
    if (warmed) return;
    warmed = true;
    document.querySelectorAll('[data-oc3-mmv] img[loading="lazy"], [data-oc3-mob] img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
  }
  head.addEventListener('pointerenter', warm, { once: true });
  head.addEventListener('focusin', warm, { once: true });
  window.addEventListener('load', function () {
    if (window.requestIdleCallback) window.requestIdleCallback(warm, { timeout: 2500 }); else setTimeout(warm, 2500);
  });

  function trigger(name) { return head.querySelector('[data-oc3-mm="' + name + '"]'); }
  function panel(name) { return mmv.querySelector('[data-oc3-panel="' + name + '"]'); }

  function placeOverlay() {
    document.documentElement.style.setProperty('--oc3-hb', Math.max(0, head.getBoundingClientRect().bottom) + 'px');
  }

  function fitHeight(animate) {
    var p = current && panel(current);
    if (!p) return;
    if (!animate) mmv.classList.add('no-anim');
    mmv.style.height = p.offsetHeight + 'px';
    if (!animate) { void mmv.offsetHeight; mmv.classList.remove('no-anim'); }
  }

  function open(name, by) {
    clearTimeout(closeTimer);
    if (!panel(name)) return;
    if (current === name) return;
    var first = !current;
    if (current) {
      panel(current).hidden = true;
      trigger(current).setAttribute('aria-expanded', 'false');
    }
    closeSearch();
    current = name;
    openedBy = by;
    openedAt = Date.now();
    panel(name).hidden = false;
    trigger(name).setAttribute('aria-expanded', 'true');
    if (first) {
      placeOverlay();
      mmv.classList.add('is-open');
      overlay.classList.add('is-on');
      fitHeight(false);
    } else {
      fitHeight(true);
    }
  }

  function close() {
    clearTimeout(closeTimer);
    if (!current) return;
    panel(current).hidden = true;
    trigger(current).setAttribute('aria-expanded', 'false');
    current = null;
    mmv.classList.add('no-anim');
    mmv.style.height = '0px';
    mmv.classList.remove('is-open');
    overlay.classList.remove('is-on');
    void mmv.offsetHeight;
    mmv.classList.remove('no-anim');
  }

  function closeSoon() {
    clearTimeout(closeTimer);
    if (current) closeTimer = setTimeout(close, 150);
  }

  function activateTab(tab) {
    var p = tab.closest('[data-oc3-panel]');
    if (!p || tab.classList.contains('is-on')) return;
    p.querySelectorAll('[data-oc3-tab]').forEach(function (t) { t.classList.toggle('is-on', t === tab); });
    p.querySelectorAll('[data-oc3-tabc]').forEach(function (c) { c.hidden = c.dataset.oc3Tabc !== tab.dataset.oc3Tab; });
    fitHeight(true);
  }

  // Hover (mouse and pen only).
  head.addEventListener('pointerover', function (e) {
    if (!desktop.matches || e.pointerType === 'touch') return;
    var t = e.target.closest('[data-oc3-mm]');
    if (t) { open(t.dataset.oc3Mm, 'hover'); return; }
    if (e.target.closest('[data-oc3-mmv]')) {
      clearTimeout(closeTimer);
      var tab = e.target.closest('[data-oc3-tab]');
      if (tab) activateTab(tab);
      return;
    }
    closeSoon();
  });
  head.addEventListener('pointerleave', function (e) {
    if (e.pointerType !== 'touch') closeSoon();
  });
  overlay.addEventListener('click', close);

  // Click and keyboard.
  head.addEventListener('click', function (e) {
    var t = e.target.closest('[data-oc3-mm]');
    if (t) {
      var name = t.dataset.oc3Mm;
      if (current === name) {
        // A click right after a hover-open keeps it open, as on the source.
        if (!(openedBy === 'hover' && Date.now() - openedAt < 600)) close();
      } else {
        open(name, 'click');
      }
      return;
    }
    if (e.target.closest('[data-oc3-quiz-open]')) close();
    var link = e.target.closest('[data-oc3-mmv] a');
    if (link) close();
  });
  head.addEventListener('focusin', function (e) {
    var tab = e.target.closest('[data-oc3-tab]');
    if (tab && current) activateTab(tab);
    if (e.target.closest('[data-oc3-mmv]')) clearTimeout(closeTimer);
  });
  head.addEventListener('focusout', function (e) {
    if (!head.contains(e.relatedTarget)) closeSoon();
  });
  head.addEventListener('keydown', function (e) {
    var t = e.target.closest('[data-oc3-mm]');
    if (t && e.key === 'ArrowDown') {
      e.preventDefault();
      open(t.dataset.oc3Mm, 'key');
      var first = panel(t.dataset.oc3Mm).querySelector('a,button');
      if (first) first.focus();
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (head.classList.contains('is-search')) { closeSearch(true); return; }
    if (current) { var t = trigger(current); close(); t.focus(); return; }
    if (mob && mob.classList.contains('is-open')) closeMob();
  });
  window.addEventListener('scroll', function () { if (current) placeOverlay(); }, { passive: true });
  desktop.addEventListener('change', function () { close(); closeSearch(); closeMob(); });

  // Search with live product results.
  var money = (function () {
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      var f = new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: cur });
      return function (v) { return f.format(Number(v)); };
    } catch (err) { return function (v) { return '$' + Number(v).toFixed(2); }; }
  })();
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function sized(url, w) { return url ? url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : ''; }

  document.querySelectorAll('[data-oc3-search]').forEach(function (form) {
    var input = form.querySelector('[data-oc3-search-input]');
    var res = form.querySelector('[data-oc3-sres]');
    var timer = null;
    var seq = 0;
    function hide() { res.hidden = true; res.innerHTML = ''; }
    form._oc3hide = hide;
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { hide(); return; }
      timer = setTimeout(function () {
        var mine = ++seq;
        var url = root + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=4&resources[options][unavailable_products]=hide';
        fetch(url, { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (data) {
            if (mine !== seq) return;
            var items = (data && data.resources && data.resources.results && data.resources.results.products) || [];
            var all = root + 'search?type=product&q=' + encodeURIComponent(q);
            if (!items.length) {
              res.innerHTML = '<p class="oc3-sres-msg">No products found for “' + esc(q) + '”.</p>';
            } else {
              res.innerHTML = items.map(function (p) {
                var was = Number(p.compare_at_price_max) > Number(p.price) ? '<s>' + money(p.compare_at_price_max) + '</s>' : '';
                var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
                return '<a class="oc3-sr" role="option" href="' + esc(p.url) + '"><img src="' + esc(sized(img, 160)) + '" alt="" width="72" height="72" loading="lazy"><span><b>' + esc(p.title) + '</b><span class="oc3-sr-p">' + was + money(p.price) + '</span></span></a>';
              }).join('') + '<a class="oc3-sres-all" href="' + esc(all) + '">See all results</a>';
            }
            res.hidden = false;
          })
          .catch(function () {});
      }, 180);
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' && !res.hidden) { var a = res.querySelector('a'); if (a) { e.preventDefault(); a.focus(); } }
    });
    res.addEventListener('keydown', function (e) {
      var links = [].slice.call(res.querySelectorAll('a'));
      var i = links.indexOf(document.activeElement);
      if (e.key === 'ArrowDown' && i < links.length - 1) { e.preventDefault(); links[i + 1].focus(); }
      if (e.key === 'ArrowUp') { e.preventDefault(); (i > 0 ? links[i - 1] : input).focus(); }
    });
    form.querySelector('[data-oc3-search-clear]').addEventListener('click', function () {
      if (input.value) { input.value = ''; hide(); input.focus(); return; }
      if (!form.classList.contains('oc3-search--always')) closeSearch(true);
    });
  });

  var deskForm = head.querySelector('.oc3-tools [data-oc3-search]');
  function openSearch() {
    close();
    head.classList.add('is-search');
    var input = deskForm.querySelector('input[type="search"]');
    setTimeout(function () { input.focus(); }, 20);
  }
  function closeSearch(refocus) {
    if (!head.classList.contains('is-search')) return;
    head.classList.remove('is-search');
    var input = deskForm.querySelector('input[type="search"]');
    input.value = '';
    deskForm._oc3hide && deskForm._oc3hide();
    if (refocus) { var b = head.querySelector('[data-oc3-search-open]'); if (b) b.focus(); }
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-oc3-search-open]');
    if (opener) {
      if (desktop.matches) openSearch(); else if (mob) { openMob(); var m = mob.querySelector('input[type="search"]'); setTimeout(function () { m.focus(); }, 320); }
      return;
    }
    if (head.classList.contains('is-search') && !e.target.closest('.oc3-tools [data-oc3-search]')) {
      var input = deskForm.querySelector('input[type="search"]');
      if (input.value.trim()) deskForm._oc3hide(); else closeSearch();
    }
  });

  // Phone menu.
  var burger = head.querySelector('[data-oc3-mob-open]');
  function openMob() {
    if (!mob || mob.classList.contains('is-open')) return;
    warm();
    mob.inert = false;
    mob.classList.add('is-open');
    document.documentElement.classList.add('oc3-lock');
    burger.setAttribute('aria-expanded', 'true');
    setTimeout(function () { var c = mob.querySelector('[data-oc3-mob-close]'); if (c && document.activeElement === burger) c.focus(); }, 300);
  }
  function closeMob() {
    if (!mob || !mob.classList.contains('is-open')) return;
    mob.classList.remove('is-open');
    mob.inert = true;
    document.documentElement.classList.remove('oc3-lock');
    burger.setAttribute('aria-expanded', 'false');
  }
  if (burger) burger.addEventListener('click', openMob);
  if (mob) {
    mob.addEventListener('click', function (e) {
      if (e.target.closest('[data-oc3-mob-close]')) { closeMob(); burger.focus(); return; }
      if (e.target.closest('[data-oc3-quiz-open]')) { closeMob(); return; }
      var a = e.target.closest('a[href]');
      if (a && a.getAttribute('href').charAt(0) === '#') closeMob();
    });
  }

  // Accordions: one open per group; height and opacity over .5s, as on the source.
  function setAcc(btn, openIt) {
    var p = document.getElementById(btn.getAttribute('aria-controls'));
    if (!p || (btn.getAttribute('aria-expanded') === 'true') === openIt) return;
    btn.setAttribute('aria-expanded', openIt ? 'true' : 'false');
    var done = function (ev) {
      if (ev && ev.propertyName !== 'height') return;
      p.removeEventListener('transitionend', done);
      p.style.height = '';
      p.style.opacity = '';
      if (!openIt) p.hidden = true;
    };
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { p.hidden = !openIt; return; }
    if (openIt) {
      p.hidden = false;
      var h = p.scrollHeight;
      p.style.height = '0px';
      p.style.opacity = '0';
      void p.offsetHeight;
      p.style.height = h + 'px';
      p.style.opacity = '1';
    } else {
      p.style.height = p.scrollHeight + 'px';
      void p.offsetHeight;
      p.style.height = '0px';
      p.style.opacity = '0';
    }
    p.addEventListener('transitionend', done);
  }
  document.querySelectorAll('[data-oc3-accs]').forEach(function (group) {
    group.addEventListener('click', function (e) {
      var btn = e.target.closest('.oc3-acc-btn');
      if (!btn || !group.contains(btn)) return;
      var openIt = btn.getAttribute('aria-expanded') !== 'true';
      if (openIt) group.querySelectorAll('.oc3-acc-btn[aria-expanded="true"]').forEach(function (b) { setAcc(b, false); });
      setAcc(btn, openIt);
    });
  });
})();
